import styled from '@emotion/styled'

import type { LazyIcon } from '../Icon/types'

import type { Position } from './types'
import { BACKGROUND_COLORS } from './utils'

const POSITION = {
  left: 'start',
  center: 'center',
  right: 'end',
}

export const SharingButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  &.--gray-icons {
    border-top: 1px solid rgba(var(--theme-palegray));

    > h3 {
      padding-top: 1.25rem;
    }

    li > button,
    li > a {
      background-color: ${BACKGROUND_COLORS.default};
    }
  }
`

export const SharingButtonsWrapper = styled.div<{
  position: Position
}>`
  display: flex;
  flex-direction: row;

  justify-content: ${({ position }) => POSITION[position]};
`

export const SharingButtonsList = styled.ul`
  display: flex;
`

export const ListItem = styled.li`
  margin: auto 0.25rem;

  &:first-of-type {
    margin-left: 0;
  }
  &:last-of-type {
    margin-right: 0;
  }
`
export const StyledButton = styled.a<{ icon: LazyIcon }>`
  background-color: unset;
  justify-content: center;
  display: flex;
  align-items: center;
  transition: ease 0.3s;
  border-radius: 50%;
  border: none;
  height: 2.5rem !important;
  width: 2.5rem !important;
  padding: 0;
  min-width: 0;

  &:hover {
    background-color: ${({ icon }) => BACKGROUND_COLORS[icon]} !important;
    cursor: pointer;
    svg {
      fill: rgb(var(--theme-snow));
      transition: ease 0.3s;
    }
  }
  svg {
    fill: rgb(var(--theme-dark-medium));
  }
`
